import { _t } from "@cruisen/i18n"
import { TripSummaryNotificationData } from "@cruisen/contract"
import { getTravelDatesText } from "@cruisen/react-shared"
import { useStores } from "../../../../models/helpers/useStores"
import styles from "./styles.module.scss"
import classNames from "classnames"

export const TripSummary = ({
  data,
  created,
}: {
  data: TripSummaryNotificationData
  created: boolean
}) => {
  const monthRange = getTravelDatesText(data.tripDateRange)

  const { loggedInUser } = useStores()

  if (loggedInUser.id === data.userId && created) return null

  const messageFrom =
    loggedInUser.id === data.userId
      ? _t("navigator.you")
      : `${data.userFirstName} ${data.userLastNameInitial}.`

  return (
    <>
      <div
        className={styles.box}
        data-testid={
          created
            ? "navigator-message-created-trip-summary"
            : "navigator-message-updated-trip-summary"
        }
      >
        <div className={styles.row}>
          <p className={styles.primaryText}>
            {created
              ? _t("notifications.tripCreated.body", { from: messageFrom })
              : _t("notifications.tripUpdated.body", { from: messageFrom })}
          </p>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.column}>
          <p className={classNames(styles.primaryText, styles.tripName)}>{data.tripName}</p>
          <p className={styles.primaryText}>
            <span className={styles.basic600Text}>
              {_t("navigatorSystemMessageComponents.departing")}
            </span>
            {data.tripOriginPortGroups.length === 1
              ? data.tripOriginPortGroups[0]
              : _t("navigatorSystemMessageComponents.multiplePorts")}
          </p>
          <p className={styles.primaryText}>
            <span className={styles.basic600Text}>
              {_t("navigatorSystemMessageComponents.sailingTo")}
            </span>
            {data.tripDestinationRegions.length !== 0
              ? data.tripDestinationRegions.length !== 1
                ? _t("navigatorSystemMessageComponents.multiplePorts")
                : data.tripDestinationRegions[0]
              : _t("navigatorSystemMessageComponents.anyPort")}
          </p>
          <p className={styles.primaryText}>
            <span className={styles.basic600Text}>
              {_t("navigatorSystemMessageComponents.dates")}
            </span>
            {monthRange}
          </p>
        </div>
      </div>
    </>
  )
}
